import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=87b4d75e&scoped=true&v-if=text&"
import script from "./Title.vue?vue&type=script&lang=ts&"
export * from "./Title.vue?vue&type=script&lang=ts&"
import style0 from "./Title.vue?vue&type=style&index=0&id=87b4d75e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b4d75e",
  null
  
)

export default component.exports